




















































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import OneMonthAddV6 from "./OneMonthAddV6.vue";
import { WageImprovement } from "@/const/wageImprovement";
import { ReceiptVisitRecord } from "#/model/receipt";

@Component
export default class OneMonthAddV7 extends OneMonthAddV6 {
  @Prop({ default: false })
  protected readonly isEnableComprehensive!: boolean;

  @Prop({ default: () => [] })
  protected readonly receiptVisitRecords!: ReceiptVisitRecord[];

  /**
   * 対象月の包括型訪問看護療養費の有無
   * 包括型を月1回以上算定している月は24時間対応体制加算（イ／ロ／包括）は算定できない。
   */
  protected get isComprehensiveBilledInMonth(): boolean {
    // 編集中の訪問は receiptVisitRecords に未反映の可能性があるため個別に見る
    if (
      this.receiptVisitRecord.comprehensive_flg == 1 ||
      this.receiptVisitRecord.comprehensive_sub_flg == 1
    ) {
      return true;
    }
    if (!this.receiptVisitRecords) {
      return false;
    }
    return this.receiptVisitRecords.some(
      rvr => rvr.comprehensive_flg == 1 || rvr.comprehensive_sub_flg == 1
    );
  }

  /** 賃金改善フラグ → 表示文字列変換（想定外の値は "なし" にフォールバック） */
  protected wageImprovementLabel(flg: number): string {
    switch (flg) {
      case WageImprovement.Both:
        return "（Ⅰ）・（Ⅱ）";
      case WageImprovement.OneOnly:
        return "（Ⅰ）";
      default:
        return "なし";
    }
  }

  // 24時間対応体制（包括）
  protected hour24_div3 = false;

  // 基底（OneMonthAdd）の24時間体制の監視処理を無効化する。
  protected handleHour24Div1() {
    // 何もしない
  }
  protected handleHour24Div2() {
    // 何もしない
  }

  // 24時間対応体制（包括） 
  @Watch("hour24_div3") protected handleMedicalHour24Div3() {
    if (!this.isLoaded) {
      return;
    }
    if (this.hour24_div3 == true) {
      this.receiptVisitRecord.hour24_div = 4;
      this.hour24_div1 = false;
      this.hour24_div2 = false;
    } else {
      if (this.hour24_div1 == false && this.hour24_div2 == false) {
        this.receiptVisitRecord.hour24_div = 0;
      }
    }
  }

  // 24時間対応体制（イ）
  @Watch("hour24_div1") protected handleMedicalHour24Div1() {
    if (!this.isLoaded) {
      return;
    }
    if (this.hour24_div1 == true) {
      this.receiptVisitRecord.hour24_div = 1;
      this.hour24_div2 = false;
      this.hour24_div3 = false;
    } else {
      if (this.hour24_div2 == false && this.hour24_div3 == false) {
        this.receiptVisitRecord.hour24_div = 0;
      }
    }
  }

  // 24時間対応体制（ロ）
  @Watch("hour24_div2") protected handleMedicalHour24Div2() {
    if (!this.isLoaded) {
      return;
    }
    if (this.hour24_div2 == true) {
      this.receiptVisitRecord.hour24_div = 3;
      this.hour24_div1 = false;
      this.hour24_div3 = false;
    } else {
      if (this.hour24_div1 == false && this.hour24_div3 == false) {
        this.receiptVisitRecord.hour24_div = 0;
      }
    }
  }

  // 24時間対応体制 初期値セット
  protected setHour24DivV2() {
    this.hour24_div1 = false;
    this.hour24_div2 = false;
    this.hour24_div3 = false;

    if (this.receiptVisitRecord.hour24_div == 1) {
      this.hour24_div1 = true;
    }
    if (this.receiptVisitRecord.hour24_div == 3) {
      this.hour24_div2 = true;
    }
    if (this.receiptVisitRecord.hour24_div == 4) {
      this.hour24_div3 = true;
    }
  }

  // 24時間体制（包括）
  protected disableCheckMedicalHour24Div3AddV2(): boolean {
    let result = false;
    if (
      this.baseDisableCheck() ||
      this.officeHistory.medical_comprehensive_flg != 1 ||
      this.officeHistory.business_div == 3
    ) {
      result = true;
    }
    return result;
  }

  // 訪問看護医療情報連携加算
  protected disableCheckInfoCollabFlg(): boolean {
    let result = false;
    if (
      this.officeHistory.medical_info_collab_add == 0 ||
      this.officeHistory.business_div == 3 ||
      this.baseDisableCheck()
    ) {
      result = true;
    }
    return result;
  }

  // 訪問看護遠隔診療補助料
  protected disableCheckRemoteSupportFlg(): boolean {
    let result = false;
    if (
      this.baseDisableCheck() ||
      this.officeHistory.medical_remote_support_div == 0
    ) {
      result = true;
    }
    return result;
  }

  //24時間体制（イ）
  protected disableCheckMedicalHour24Div1AddV2(): boolean {
    let result = false;
    if (
      this.baseDisableCheck() ||
      this.officeHistory.medical_hour24_taiou_add != 1 ||
      this.officeHistory.medical_is_hour24_taiou_reduce_burden != 1 ||
      this.officeHistory.business_div == 3
    ) {
      result = true;
    }
    return result;
  }

  //24時間体制（ロ）
  protected disableCheckMedicalHour24Div2AddV2(): boolean {
    let result = false;
    if (
      this.baseDisableCheck() ||
      this.officeHistory.medical_hour24_taiou_add != 1 ||
      this.officeHistory.medical_is_hour24_taiou_reduce_burden == 1 ||
      this.officeHistory.business_div == 3
    ) {
      result = true;
    }
    return result;
  }

  // 登録時に、disabledの項目は0にする
  public clearDisableItemV7() {
    //ターミナルケアと遠隔死亡診断補助
    if (this.disableCheckMedicalTerminalDivV4()) {
      this.medical_terminal_div1 = false;
      this.medical_terminal_div2 = false;
      this.receiptVisitRecord.medical_terminal_div = 0;
    }
    if (this.disableCheckMedicalRemoteDeathAssistV4()) {
      this.receiptVisitRecord.remote_death_assist = 0;
    }
    //特別管理指導
    if (this.disableCheckSpecialInstFlg()) {
      this.receiptVisitRecord.special_inst_flg = 0;
    }
    //24時間体制（イ）
    if (this.disableCheckMedicalHour24Div1AddV2() && this.receiptVisitRecord.hour24_div == 1) {
      this.hour24_div1 = false;
      this.receiptVisitRecord.hour24_div = 0;
    }
    //24時間体制（ロ）
    if (this.disableCheckMedicalHour24Div2AddV2() && this.receiptVisitRecord.hour24_div == 3) {
      this.hour24_div2 = false;
      this.receiptVisitRecord.hour24_div = 0;
    }
    //24時間体制（包括）
    if (this.disableCheckMedicalHour24Div3AddV2() && this.receiptVisitRecord.hour24_div == 4) {
      this.hour24_div3 = false;
      this.receiptVisitRecord.hour24_div = 0;
    }
    //特別管理加算
    if (
      this.disableCheckMedicalSpecialDiv1() &&
      this.disableCheckMedicalSpecialDiv2() &&
      this.disableCheckMedicalSpecialDiv3()
    ) {
      this.medical_special_div1 = false;
      this.medical_special_div2 = false;
      this.medical_special_div3 = false;
      this.receiptVisitRecord.medical_special_div = 0;
    }
    //在宅患者連携指導
    if (this.disableCheckHomeInstFlg()) {
      this.receiptVisitRecord.home_inst_flg = 0;
    }
    //精神科重症患者支援管理連携加算
    if (this.disableCheckMentalSupportDivV2()) {
      this.mental_support_div1 = false;
      this.mental_support_div2 = false;
      this.receiptVisitRecord.mental_support_div = 0;
    }
    //情報提供療養費
    if (this.disableCheckInfoExpensesFlgV2()) {
      this.receiptVisitRecord.info_expenses_flg1 = 0;
      this.receiptVisitRecord.info_expenses_flg2 = 0;
      this.receiptVisitRecord.info_expenses_flg3 = 0;
    }
    //情報提供療養費（II）回数
    if (this.disableCheckInfoExpenses2Count()) {
      this.receiptVisitRecord.info_expenses2_count = 0;
    }
    //看護・介護職員連携
    if (this.disableCheckNursingCareFlg()) {
      this.nursing_care_flg = false;
      this.receiptVisitRecord.nursing_care_flg = 0;
    }
    //看護・介護職員連携日
    if (this.disableCheckNursingCareDate()) {
      this.receiptVisitRecord.nursing_care_date = "";
    }
    //専門管理加算
    if (this.disableCheckSpecialManagementAddV4()) {
      this.receiptVisitRecord.special_management_add = 0;
    }
    // DX情報活用加算
    if (this.disableCheckDxInfoUtilFlg()) {
      this.receiptVisitRecord.dx_info_util_flg = 0;
    }
    // 訪問看護医療情報連携加算
    if (this.disableCheckInfoCollabFlg()) {
      this.receiptVisitRecord.info_collab_flg = 0;
    }
    // ベースアップ評価料
    if (this.disableCheckBaseUp1Flg()) {
      this.receiptVisitRecord.base_up1_flg = 0;
    }
    // 訪問看護遠隔診療補助料
    if (this.disableCheckRemoteSupportFlg()) {
      this.receiptVisitRecord.remote_support_flg = 0;
    }
  }
}
